export default __webpack_public_path__ + "static/challenge-66e31a560300e4d7049ae1a6e8ebf170.png";